
import ParticipantGroupRegistrationRequest from "@/models/api/participant-group/ParticipantGroupRegisterRequest";
import Person from "@/models/api/person/Person";
import PersonRegistrationRequest from "@/models/api/person/PersonRegistrationRequest";
import VuetifyFormMethods from "@/models/vuetify-form-methods";
import { ParticipantService } from "@/services/ParticipantService";
import { PersonService } from '@/services/PersonService';
import { SnackbarService } from "@/services/SnackbarService";
import Vue from 'vue'
import { SettingService } from '../../services/SettingService';
import { ApplicationSetting, AssociationRoleEnum } from '../../models/Enums';
import ApplicationSettingDto from '../../models/api/ApplicationSetting';
import adaptSSN from '../../helpers/functions/AdaptSSN';
import adaptZipCode from '../../helpers/functions/AdaptZipCode';
import { validateSSNDate, validateDateOfBirth, validateSSN } from '../../helpers/functions/ValidateSSN';
import validateSSNSetting from '../../helpers/functions/ValidateSSNSetting';
import { ValidationHelper } from '../../helpers/ValidationHelper';

export default Vue.extend({
    props: {
        showDialog: Boolean,
        itemIdToBeEdited: Number    
    },
    created() {

        
        this.editParticipantDialogOpen = this.showDialog;
     
        this.preparePersonEdit(this.itemIdToBeEdited);


        SettingService.GetSettingsByKeyNames("IsSSNMandatory,FormatOfDateOfBirth")
            .then(response => {
                const settings = response.data as ApplicationSettingDto[];
                this.isSSNMandatory = JSON.parse(settings[this.getApplicationSetting(settings, ApplicationSetting.IsSSNMandatory)].value.toString().toLowerCase());
                this.formatDateOfBirth = settings[this.getApplicationSetting(settings, ApplicationSetting.FormatOfDateOfBirth)].value.toString();
            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                this.$store.commit('removeOverlay');
            });

    },
    data() {
        return {
            editParticipantDialogOpen: false,    
      
            personRequest: {} as Person,
            participantRequest: new ParticipantGroupRegistrationRequest(0, 0, 0, false, false, false, false),
       
            participantRequestValid: false,

            oldEmail: "",
            oldAssociationRole: null as AssociationRoleEnum | null,
            showEmailWillBeUpdatedInformation: false,

          
            genders: [{ text: this.$vuetify.lang.t('$vuetify.female'), value: 1 }, { text: this.$vuetify.lang.t('$vuetify.male'), value: 2 }],

            isSSNMandatory: false,
            formatDateOfBirth: "",
            rules: {
                required: (value: any) => !!value || this.$vuetify.lang.t('$vuetify.required'),
                ssnFormat: (value: any) => !value || /^\d{4}\d{2}\d{2}-\d{4}$/.test(value) || this.$vuetify.lang.t('$vuetify.formatSSN'),
                validateSSNDate: (value: any) => validateSSNDate(value) || this.$vuetify.lang.t('$vuetify.person.invalidDate'),
            },
            phoneRules: [
                (v: any) => /^((\+\d{1,3}\s*[0-9]{1,3})|(0[0-9]{1,3}))-*\s*(\d{3,4})\s*(\d{2,3})\s*(\d{1,3})*$/.test(v) || v == null || v == "" || this.$vuetify.lang.t('$vuetify.person.invalidPhoneNumber'),
            ],
            zipCodeRules: [
                (value: any) => !value || /^\d{3}\s*\d{2}$/.test(value) || this.$vuetify.lang.t('$vuetify.invalidZipCode'),
            ],
            emailRules: [
                (value: any) => !value
                    || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
                    || this.$vuetify.lang.t('$vuetify.invalidEmail'),
            ]

            
        }
    },
    watch: {
        showDialog: {
            handler(newValue) {
                this.editParticipantDialogOpen = this.showDialog;
                           
                if (this.showDialog) {
                    this.resetData();
                }
            }
        },       
    },
    methods: {
        getValidationRules(): any[] {
            setTimeout(() => (this.$refs.personDialog as VuetifyFormMethods)?.validate());
            if (this.isSSNMandatory && !this.personRequest.hasNoSwedishSsn) {
                return [this.rules.validateSSNDate, this.validateSSNSettings, this.checkValidSSN, this.rules.required, this.rules.ssnFormat];
            }
            return [this.rules.validateSSNDate, this.validateSSNSettings, this.checkValidSSN, this.rules.required, this.validDateOfBirth];
        },
        validDateOfBirth(value: string): string | boolean {
            return validateDateOfBirth(value, this.formatDateOfBirth) || this.$vuetify.lang.t('$vuetify.person.invalidDate');
        },
        checkValidSSN(value: string): string | boolean {
            return validateSSN(value) || this.$vuetify.lang.t('$vuetify.invalidSSN');
        },
        validateSSNSettings(v: any): boolean | string {
            return validateSSNSetting(v, this.isSSNMandatory && !this.personRequest.hasNoSwedishSsn, this.formatDateOfBirth) || this.$vuetify.lang.t('$vuetify.invalidSSN');
        },
        fixSSN() {
            this.personRequest.socialSecurityNumber = adaptSSN(this.personRequest.socialSecurityNumber);
        },
        fixZipCode() {
            this.personRequest.zipCode = adaptZipCode(this.personRequest.zipCode);
        },

        getApplicationSetting(settings: ApplicationSettingDto[], app: ApplicationSetting) {
            return settings.findIndex((val: any) => val.keyName == app);
        },      

        changeEmail(newEmail: any) {
    
            if ((this.oldAssociationRole == AssociationRoleEnum.AssociationAdmin || this.oldAssociationRole == AssociationRoleEnum.AssociationGroupAdmin) && this.oldEmail != "" && this.oldEmail != newEmail) {
                this.showEmailWillBeUpdatedInformation = true;
            }
            else {
                this.showEmailWillBeUpdatedInformation = false;
            }
        },

        preparePersonEdit(itemId: number): void {
          
            // Keeps row in datatable the same, whilst updating the values.
            this.$store.commit('addOverlay');
            PersonService.GetPerson(itemId).then(response => {
                this.personRequest = response.data;
                this.oldEmail = this.personRequest.email;
                this.oldAssociationRole = this.personRequest.associationRole;
                this.showEmailWillBeUpdatedInformation = false;

            }).catch((error) => {
                SnackbarService.addErrorMessage(
                    error.response?.data || error.response?.statusText
                );
            })
            .finally(() => {
                this.$store.commit('removeOverlay');
            });

        },

        saveEdit() {

            if (!(this.$refs.personDialog as VuetifyFormMethods).validate()) {
                return;
            }

            PersonService.EditPerson(this.personRequest, "").then((result) => {     
             
                this.participantRequest.personId = this.personRequest.id;
                this.participantRequest.person = this.personRequest;

                SnackbarService.addSuccessMessage(result?.data);

                this.emitParticipant();
              // this.$emit("dialog-closed");

            }).catch(error => {
                  
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                });
           
        },
        resetData(): void {
            this.personRequest = {} as Person;
            this.participantRequest = new ParticipantGroupRegistrationRequest(0, 0, 0, false, false, false, false);
            if (this.$refs.personDialog) {
                (this.$refs.personDialog as VuetifyFormMethods).resetValidation();
            }

        },
       
        emitParticipant() {
            this.$emit("participant-updated", this.participantRequest);
        },
        dialogClosed() {
            (this.$refs.personDialog as VuetifyFormMethods).reset();
            // this.resetData();
            this.$emit("dialog-closed");
        },
    }
})
